import fa from "element-ui/src/locale/lang/fa";

export const tableOption = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '姓名',
            prop: 'username'
        },
        {
            label: '邀请人数',
            prop: 'count'
        }
    ]
}

export const tableOption2 = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '姓名',
            prop: 'username'
        },
        {
            label: '来源',
            prop: 'reg_type',
            dicData:[
                {
                    label: 'App端',
                    value: 0
                },
                {
                    label: 'PC端',
                    value: 1
                },
                {
                    label: '小程序',
                    value: 2
                },
                {
                    label: 'H5',
                    value: 4
                }
            ]
        }
    ]
}


export const tableOption3 = {
    dialogDrag: true,
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '平台',
            prop: 'name'
        },
        {
            label: '总数',
            prop: 'count',
           
        }
    ]
}

export const tableOption4 = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '用户名',
            prop: 'username'
        },
        // {
        //     label: '点击次数',
        //     prop: 'num'
        // },
        {
            label: '渠道',
            prop: 'type',
            dicData:[
                {
                    label: 'PC端',
                    value: 1
                },
                {
                    label: 'APP端',
                    value: 2
                },
                {
                    label: '小程序',
                    value: 3
                }
            ]
        },
        {
            label: '点击时间',
            prop: 'createtime_text'
        },
        // {
        //     label: '最后一次点击时间',
        //     prop: 'updatetime_text'
        // },
    ]
}

export const tableOption5 = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '用户名',
            prop: 'username'
        },
        {
            label: '时间',
            prop: 'time_text'
        },
    ]
}

export const tableOption6 = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '用户名',
            prop: 'username'
        },
        {
            label: '时间',
            prop: 'addtime_text'
        },
        {
            label: '渠道',
            prop: 'type_text'
        },
    ]
}

export const tableOption7 = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '用户ID',
            prop: 'username'
        },
        {
            label: '活跃次数',
            prop: 'num'
        },
        
    ]
}

export const tableOption8 = {
    dialogDrag: true,
    index: true,
    indexLabel: '序号',
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: false,
    indexFixed: false,
    printBtn: false,
    viewBtn: false,
    addBtn: false,
    delBtn: false,
    editBtn: false,
    refreshBtn: false,
    columnBtn: false,
    border: false,
    menu: false,
    dialogMenuPosition:'center',
    menuWidth: 150,
    header: false,
    column: [
        {
            label: '城市',
            prop: 'name'
        },
        {
            label: '用户数',
            prop: 'num'
        },
        
    ]
}